import script from "./AdminToolIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminToolIndex.vue?vue&type=script&setup=true&lang=js"

import "./AdminToolIndex.vue?vue&type=style&index=0&id=75e6b085&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75e6b085"]])

export default __exports__